/* In this file code for when custom section javascript code are render on this file */

/* ===============================
   GLOBAL HERO SLIDER COMPONENT
=============================== */
class GlobalHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex  = 1;
    this.isTransitioning = false;
    this.slideWidth    = 0;
    this.autoplayInterval = null;
  }

  connectedCallback() {
    this.track         = this.querySelector('[data-track]');
    this.prevButton    = this.querySelector('[data-prev]');
    this.nextButton    = this.querySelector('[data-next]');
    this.dotsContainer = this.querySelector('[data-dots]');

    this.originalSlides = Array.from(
      this.querySelectorAll('.ai-hero-slide:not([data-clone])')
    );

    if (this.originalSlides.length <= 1) {
      if (this.dotsContainer) this.dotsContainer.style.display = 'none';
      return;
    }

    this.track.querySelectorAll('[data-clone]').forEach(c => c.remove());
    this.createClones();
    this.allSlides = Array.from(this.track.children);

    this.calculateWidth();
    this.setupDots();
    this.setupEvents();
    this.updatePosition(true);
    this.startAutoplay();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.calculateWidth();
        this.updatePosition(true);
      }, 100);
    });

    if (this.prevButton)   this.prevButton.style.display   = 'flex';
    if (this.nextButton)   this.nextButton.style.display   = 'flex';
    if (this.dotsContainer) this.dotsContainer.style.display = 'flex';
  }

  calculateWidth() {
    const slide = this.allSlides[0];
    if (!slide) return;
    this.slideWidth = slide.getBoundingClientRect().width;
  }

  createClones() {
    const first = this.originalSlides[0];
    const last  = this.originalSlides[this.originalSlides.length - 1];
    const firstClone = first.cloneNode(true);
    const lastClone  = last.cloneNode(true);

    firstClone.setAttribute('data-clone', 'true');
    lastClone.setAttribute('data-clone', 'true');

    this.track.appendChild(firstClone);
    this.track.insertBefore(lastClone, first);
  }

  setupDots() {
    if (!this.dotsContainer) return;
    this.dotsContainer.innerHTML = '';
    this.originalSlides.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.className = 'ai-hero-slider-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
      dot.addEventListener('click', () => {
        if (this.isTransitioning) return;
        this.currentIndex = idx + 1;
        this.updatePosition();
        this.restartAutoplay();
      });
      this.dotsContainer.appendChild(dot);
    });
    this.updateDots();
  }

  updateDots() {
    if (!this.dotsContainer) return;
    const dots = this.dotsContainer.querySelectorAll('.ai-hero-slider-dot');
    let real = this.currentIndex - 1;
    if (real >= this.originalSlides.length) real = 0;
    if (real < 0) real = this.originalSlides.length - 1;
    dots.forEach((d, i) => d.classList.toggle('active', i === real));
  }

  setupEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        if (!this.isTransitioning) { this.prev(); this.restartAutoplay(); }
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        if (!this.isTransitioning) { this.next(); this.restartAutoplay(); }
      });
    }

    this.track.addEventListener('transitionend', () => this.handleInfinite());

    let startX = 0;
    this.track.addEventListener('touchstart', e => {
      if (this.isTransitioning) return;
      startX = e.touches[0].clientX;
      this.stopAutoplay();
    }, { passive: true });

    this.track.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - startX;
      if (diff < -50) this.next();
      else if (diff > 50) this.prev();
      this.startAutoplay();
    }, { passive: true });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
  }

  next() { this.currentIndex++; this.updatePosition(); }
  prev() { this.currentIndex--; this.updatePosition(); }

  handleInfinite() {
    this.isTransitioning = false;
    const current = this.allSlides[this.currentIndex];
    
    if (current && current.dataset.clone === 'true') {
      if (this.currentIndex === 0) {
        this.currentIndex = this.originalSlides.length;
      } else if (this.currentIndex === this.allSlides.length - 1) {
        this.currentIndex = 1;
      }
      
      void this.track.offsetWidth; // Force reflow
      this.updatePosition(true);
    }
  }

  updatePosition(noAnimation = false) {
    this.calculateWidth();
    if (this.currentIndex >= this.allSlides.length) this.currentIndex = 1;
    if (this.currentIndex < 0) this.currentIndex = this.originalSlides.length;

    if (noAnimation) {
      this.isTransitioning = false;
      this.track.style.transition = 'none';
      this.track.classList.remove('transitioning');
    } else {
      this.isTransitioning = true;
      this.track.style.transition = ''; 
      this.track.classList.add('transitioning');
    }

    this.track.style.transform = `translate3d(${-this.currentIndex * this.slideWidth}px, 0, 0)`;
    this.updateDots();
  }

  startAutoplay() {
    const enabled = this.dataset.autoplay === 'true';
    const speed   = parseInt(this.dataset.speed, 10) || 5000;
    if (!enabled) return;
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      if (!this.isTransitioning) this.next();
    }, speed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

// Ensure it only gets defined once
if (!customElements.get('global-hero-slider')) {
  customElements.define('global-hero-slider', GlobalHeroSlider);
}

// End Hero banner code 


// category show case (Tabify category block code)

/* Utilizes standard Web Component Custom Element structure.s
   Settings are safely extracted from the dataset API. */

if (!customElements.get('category-showcase')) {
  class CategoryShowcase extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.ai-carousel-track');
      this.slides = this.querySelectorAll('.ai-carousel-slide');
      this.prevBtn = this.querySelector('.ai-arrow-prev');
      this.nextBtn = this.querySelector('.ai-arrow-next');
      this.currentIndex = 0;

      // Extract settings from the wrapper element's data attributes
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.speed, 10) || 4000;
      this.autoplayTimer = null;

      if (!this.track || this.slides.length <= 1) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => { 
          e.preventDefault(); 
          this.moveSlide(-1); 
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => { 
          e.preventDefault(); 
          this.moveSlide(1); 
        });
      }

      // Touch / Swipe handling
      let startX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.stopAutoplay();
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        let diff = e.changedTouches[0].clientX - startX;
        if (diff < -40) this.moveSlide(1);
        if (diff > 40) this.moveSlide(-1);
        isDragging = false;
        this.startAutoplay();
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());

      if (this.autoplayEnabled) {
        this.startAutoplay();
      }
    }

    moveSlide(direction) {
      this.currentIndex += direction;
      if (this.currentIndex < 0) {
        this.currentIndex = this.slides.length - 1;
      } else if (this.currentIndex >= this.slides.length) {
        this.currentIndex = 0;
      }
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.moveSlide(1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define('category-showcase', CategoryShowcase);
}

// End code 


 